import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { ChevronDownDDS } from "../../../../asset";
import { Checkbox } from "antd";
import style from "../../mss.module.css";

const listDayOff = [
  "Select All",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const MSSAddDayOff = ({
  children,
  className,
  togglerClassName,
  placeholder,
  setVal,
  val,
  ...attrs
}) => {
  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [valueMSS, setValueMSS] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const getValueMSS = useCallback(
    (item) => {
      if (!valueMSS && item !== "Select All") {
        const value = [];
        value.push(item);
        setValueMSS(value);
        setVal(value);
        return;
      }
      if (!valueMSS && item === "Select All") {
        const newListDayOff = listDayOff.filter((day) => day !== "Select All");
        setValueMSS(newListDayOff);
        setVal(newListDayOff);
        return;
      }
      const listValueMSS = valueMSS;

      if (valueMSS && item === "Select All") {
        if (listValueMSS.length === 7) {
          setValueMSS();
          setVal();
        } else {
          const newListDayOff = listDayOff.filter(
            (day) => day !== "Select All"
          );
          setValueMSS(newListDayOff);
          setVal(newListDayOff);
        }
        return;
      }

      let idxOfItem = listValueMSS.indexOf(item);

      if (idxOfItem !== -1) {
        listValueMSS.splice(idxOfItem, 1);

        setValueMSS([...listValueMSS]);
        setVal([...listValueMSS]);
      } else {
        listValueMSS.push(item);
        listValueMSS.sort(function (a, b) {
          var order = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          return order.indexOf(a) - order.indexOf(b);
        });

        setValueMSS([...listValueMSS]);
        setVal([...listValueMSS]);
      }
    },
    [setVal, valueMSS]
  );

  const isChecked = useCallback(
    (item) => {
      if (!valueMSS) {
        return false;
      }
      const listValueMSS = valueMSS;
      if (listValueMSS.length === 7) {
        return true;
      }
      const isExist = listValueMSS.some((el) => el === item);
      return isExist;
    },
    [valueMSS]
  );

  const marginTopDropdown = useMemo(() => {
    if (!valueMSS) {
      return "mt-5";
    }
    if (valueMSS && valueMSS.length > 5) {
      return "mt-14";
    }
    return "mt-5";
  }, [valueMSS]);

  useEffect(() => {
    if (!val) {
      return;
    }
    setValueMSS(val);
    setVal(val);
  }, [setVal, val]);

  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="w-full border border-gray-200 flex flex-wrap gap-4 justify-between px-[6px] rounded-md min-h-[47px] items-center"
        onClick={togglerDropdownContent}
      >
        {!valueMSS || valueMSS.length === 0 ? (
          <span className="text-base text-gray-200 opacity-70">
            Select Day Off
          </span>
        ) : (
          <div className="max-w-[90%] flex flex-wrap gap-2 my-2">
            {valueMSS.map((item, index) => (
              <span
                className="bg-red-100 text-white-100 text-sm font-semibold px-2 py-1 rounded-2xl"
                key={index}
              >
                {item}
              </span>
            ))}
          </div>
        )}

        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </button>
      <div
        className={"dropdown-menu".concat(
          isShowDropdownContent ? ` active ${marginTopDropdown}` : ""
        )}
        ref={dropdownContentRef}
      >
        <ul className="overflow-auto max-h-[300px]">
          {listDayOff.map((item, index) => (
            <li
              key={index}
              className={"dropdown-item"}
              onClick={() => getValueMSS(item)}
            >
              <div className="flex justify-between">
                <span>{item}</span>
                <Checkbox
                  className={style.checkboxMSS}
                  checked={isChecked(item)}
                />
              </div>
            </li>
          ))}
          <li></li>
        </ul>
      </div>
    </div>
  );
};

export default MSSAddDayOff;
